(function () {
  'use strict';

  var STORAGE_SELECTED = 'user_region_selected';
  var STORAGE_DISMISSED = 'geo_prompt_dismissed';
  var SESSION_DETECTED = 'geo_detected_country';

  // Set once in init(), used by showGeoPopup()
  var shopName = '';

  // Parsed once in init(), reused in switchToCountry()
  var geoData = null;

  function init() {
    // Selection persists in localStorage, but dismissal is per-session
    if (localStorage.getItem(STORAGE_SELECTED)) return;
    if (sessionStorage.getItem(STORAGE_DISMISSED)) return;

    if (new URLSearchParams(window.location.search).get('region') === 'manual') return;

    var dataEl = document.getElementById('geo-data');
    if (!dataEl) return;

    try { geoData = JSON.parse(dataEl.textContent); } catch (e) { return; }

    shopName = geoData.shopName || '';

    var current = geoData.current;
    var countries = geoData.countries || [];
    var available = countries.map(function (c) { return c.iso; });

    // Shopify server-side detection (most reliable)
    if (geoData.detected) {
      evaluate(geoData.detected, current, available, countries);
      return;
    }

    // Cached result from this browser session
    var cached = sessionStorage.getItem(SESSION_DETECTED);
    if (cached) {
      evaluate(cached, current, available, countries);
      return;
    }

    // Fallback: IP-based detection, non-blocking (chained for resilience)
    detectCountryByIp(function (code) {
      sessionStorage.setItem(SESSION_DETECTED, code);
      evaluate(code, current, available, countries);
    });
  }

  function detectCountryByIp(callback) {
    fetch('https://ipwho.is/')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.country_code) { callback(d.country_code); return; }
        throw new Error('no country_code');
      })
      .catch(function () {
        fetch('https://ipapi.co/json/')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (d && d.country_code) callback(d.country_code);
          })
          .catch(function () { });
      });
  }

  function getCountry(isoCode, countries) {
    return (countries || []).find(function (c) { return c.iso === isoCode; }) || null;
  }

  function evaluate(detected, current, available, countries) {
    if (!detected || detected === current) return;
    if (available.indexOf(detected) === -1) return;

    var detectedCountry = getCountry(detected, countries);
    var currentCountry  = getCountry(current, countries);
    var detectedName = detectedCountry ? detectedCountry.name : detected;
    var currentName  = currentCountry  ? currentCountry.name  : current;
    showGeoPopup(detected, detectedName, currentName);
  }

  // ── Market switching ─────────────────────────────────────────────────────────

  function switchToCountry(isoCode) {
    var defaultLang = null;
    if (geoData) {
      var c = getCountry(isoCode, geoData.countries);
      if (c) defaultLang = c.defaultLang || null;
    }

    if (window.MarketModal && typeof window.MarketModal.selectCountry === 'function') {
      window.MarketModal.selectCountry(isoCode, defaultLang);
      return;
    }

    var form = document.getElementById('market_modal_form')
      || document.getElementById('localization_form_footer')
      || document.getElementById('localization_form_header');
    if (!form) return;

    var countryInput = form.querySelector('[name="country_code"]');
    var localeInput  = form.querySelector('[name="locale_code"]');
    if (!countryInput) return;

    countryInput.value = isoCode;
    if (localeInput) {
      if (defaultLang) {
        localeInput.value = defaultLang;
        localeInput.disabled = false;
      } else {
        // Omit locale_code so Shopify resets to the target market's primary language
        localeInput.disabled = true;
      }
    }
    form.submit();
  }

  // ── Geo popup ────────────────────────────────────────────────────────────────

  function closeGeoPopup() {
    var el = document.getElementById('geo-suggest-overlay');
    if (el) el.parentNode.removeChild(el);
  }

  function showGeoPopup(detectedIso, detectedName, currentName) {
    /* ── Overlay ── */
    var overlay = document.createElement('div');
    overlay.id = 'geo-suggest-overlay';

    /* ── Modal card ── */
    var modal = document.createElement('div');
    modal.id = 'geo-suggest-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'geo-suggest-heading');

    /* ── Close button (absolutely positioned top-right) ── */
    var closeBtn = document.createElement('button');
    closeBtn.id = 'geo-suggest-close';
    closeBtn.className = 'no-hover';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" ' +
      'stroke="currentColor" stroke-width="1.5" width="16" height="16" aria-hidden="true">' +
      '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';

    /* ── Header ── */
    var header = document.createElement('div');
    header.id = 'geo-suggest-header';

    var heading = document.createElement('h2');
    heading.id = 'geo-suggest-heading';
    heading.textContent = 'Welcome';
    header.appendChild(heading);

    var subheading = document.createElement('p');
    subheading.id = 'geo-suggest-subheading';
    var boutiqueName = shopName ? shopName + ' boutique' : 'our boutique';
    subheading.innerHTML =
      'You are switching to the ' + esc(boutiqueName) + ' for <strong>' + esc(detectedName) + '</strong>.';
    header.appendChild(subheading);

    /* ── Body ── */
    var body = document.createElement('div');
    body.id = 'geo-suggest-body';

    // Curation note
    var note1 = document.createElement('p');
    note1.className = 'geo-suggest-note';
    note1.textContent =
      'Each boutique is curated by country to provide precise pricing, taxes, and delivery services.';

    // Cart/wishlist note
    var note2 = document.createElement('p');
    note2.className = 'geo-suggest-note';
    note2.textContent = 'Your Cart and Wishlist will adjust accordingly.';

    // CTAs
    var actions = document.createElement('div');
    actions.className = 'geo-suggest-actions';

    var confirmBtn = document.createElement('button');
    confirmBtn.id = 'geo-suggest-confirm';
    confirmBtn.className = 'no-hover';
    confirmBtn.textContent = 'Continue';

    var stayBtn = document.createElement('button');
    stayBtn.id = 'geo-suggest-stay';
    stayBtn.className = 'no-hover';
    stayBtn.textContent = 'Stay in ' + currentName;

    actions.appendChild(confirmBtn);
    actions.appendChild(stayBtn);

    // Footer note with "Choose your location" link
    var footer = document.createElement('p');
    footer.id = 'geo-suggest-footer';

    var chooseLink = document.createElement('a');
    chooseLink.id = 'geo-suggest-choose';
    chooseLink.href = '#';
    chooseLink.textContent = 'choose your location';

    footer.appendChild(document.createTextNode(
      'If you would like to purchase from another country, please '
    ));
    footer.appendChild(chooseLink);
    footer.appendChild(document.createTextNode('.'));

    body.appendChild(note1);
    body.appendChild(note2);
    body.appendChild(actions);
    body.appendChild(footer);

    modal.appendChild(closeBtn);
    modal.appendChild(header);
    modal.appendChild(body);
    overlay.appendChild(modal);
    document.body.appendChild(overlay);

    requestAnimationFrame(function () { confirmBtn.focus(); });

    /* ── Handlers ── */

    function dismiss() {
      sessionStorage.setItem(STORAGE_DISMISSED, '1');
      closeGeoPopup();
    }

    confirmBtn.addEventListener('click', function () {
      localStorage.setItem(STORAGE_SELECTED, detectedIso);
      closeGeoPopup();
      switchToCountry(detectedIso);
    });

    stayBtn.addEventListener('click', dismiss);
    closeBtn.addEventListener('click', dismiss);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) dismiss();
    });

    chooseLink.addEventListener('click', function (e) {
      e.preventDefault();
      sessionStorage.setItem(STORAGE_DISMISSED, '1');
      closeGeoPopup();
      if (window.MarketModal) {
        window.MarketModal.open({ highlightCountry: detectedIso });
      }
    });

    document.addEventListener('keydown', function onEsc(e) {
      if (e.key === 'Escape') {
        dismiss();
        document.removeEventListener('keydown', onEsc);
      }
    });
  }

  /* ── Utilities ── */

  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ── Boot ── */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
